<template>
  <b-table show-empty striped hover class="aco-table"
           :items="users" :fields="userFields" style="white-space: pre-line">

    <template #head(remove)>
      <input
        v-model="checkAll"
        type="checkbox"
        name="checkAll"
        :value="true"
        @change="toggleAll"
      />
    </template>

    <template slot="empty">
      <div class="text-center">{{ $t('userFilter.emptyTable') }}</div>
    </template>

    <template #cell(schoolOrganizations)="data">
      <div v-for="organization in data.item.schoolOrganizations" v-bind:key="organization.number"
           @click="showSchoolDetails(organization.number)" class="aco-table-link">
        {{ organization.name + ' ' + '(' + organization.number + ')' }}
      </div>
    </template>

    <template v-slot:cell(show_details)="row">
      <router-link :to="{ name: 'UserDetails', params: { id: row.item.userId }}">
        <b-button size="sm" class="aco-table-button">{{ $t('details') }}</b-button>
      </router-link>
      <b-button size="sm" class="py-0 mr-3" v-if="!isActiveProfileSet" v-on:click="updateSessionStorage(row.item.userId, row.item.fullName)">
        {{ $t('use') }}
      </b-button>
    </template>

    <template #cell(remove)="data">
      <input
        type="checkbox"
        v-model="toRemove"
        name="leaveOrganization"
        :id="`user-${data.item.userId}`"
        :value="data.item.userId"
        :disabled="!canLeaveOrganization(data.item)"
      >
    </template>
  </b-table>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters } from 'vuex'

  export default {
    name: 'UserList',
    extends: BaseComponent,

    mounted: function () {
      this.$store.dispatch('users/getUsers')
      this.$store.dispatch('sessionStorage/checkSessionStorage')
    },

    data: () => ({
      checkAll: false
    }),

    computed: {
      ...mapGetters('users', ['users']),
      ...mapGetters('sessionStorage', ['isActiveProfileSet', 'activeProfile']),
      toRemove: {
        get(){
          return this.$store.state.users.leaveOrganization
        },
        set(userIds){
          this.$store.state.users.leaveOrganization = userIds
        }
      },
      userFields () {
        return [
          ...(this.isActiveProfileSet ? [{ key: 'remove', label: this.$t('remove')}] : []),
          ...[
            { key: 'username', label: this.$t('username') },
            { key: 'primaryRole', label: this.$t('role'), formatter: value => this.translateAlternatives('userPrimaryRoles', value) },
            { key: 'source', label: this.$t('source'), formatter: value => this.translateAlternatives('userSources', value) },
            { key: 'fullName', label: this.$t('fullName'), tdClass: 'text-nowrap' },
            { key: 'email', label: this.$t('email'), tdClass: 'text-nowrap' },
            { key: 'schoolOrganizations', label: this.$t('school') },
            { key: 'active', label: this.$t('active'), formatter: 'translateBooleans' },
            { key: 'show_details', label: '', tdClass: 'text-nowrap' }
          ]
        ]
      }
    },
    methods: {
      toggleAll() {
        this.toRemove = this.checkAll
          ? this.users.filter(user => this.canLeaveOrganization(user)).map(user => user.userId)
          : []
      },
      canLeaveOrganization(user) {
        return ['LOCAL', 'VIPPS'].includes(user.source)
          && this.activeProfile
          && user.schoolOrganizations.some(({ number }) => number === this.activeProfile.id)
      },
      updateSessionStorage (id, name) {
        let sessionStorageRequest = {
          activeProfileType: 'user',
          id: id,
          name: name
        }
        this.$store.dispatch('sessionStorage/updateSessionStorage', sessionStorageRequest)
        this.$router.push('/licenses')
      },
      showSchoolDetails (organizationNumber) {
        this.$router.push('/organizations/' + organizationNumber)
      }
    }
  }
</script>
